var _path, _path2, _ellipse, _ellipse2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRedemptionFailedUser = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.527301 15.7207H1.5819C1.87311 15.7207 2.1092 15.4863 2.1092 15.1972V9.43945H0.527301C0.23609 9.43945 0 9.67381 0 9.96289V15.1972C0 15.4863 0.23609 15.7207 0.527301 15.7207Z",
    fill: "#5D5CF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.069 0C8.846 0 7.04395 1.78884 7.04395 3.99555C7.04395 6.20219 8.846 7.9911 11.069 7.9911C13.292 7.9911 15.0941 6.20219 15.0941 3.99555C15.0941 1.78884 13.292 0 11.069 0Z",
    fill: "#5D5CF5"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.0686,
    cy: 3.99471,
    rx: 3.0188,
    ry: 2.99666,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.0693,
    cy: 3.99666,
    rx: 2.31442,
    ry: 2.29744,
    fill: "#5D5CF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51983 15.9997H9.63584C11.4076 15.9787 13.1054 15.4798 14.603 14.5794L17.5453 12.5381C18.041 12.1926 18.1359 11.5435 17.809 11.0829C17.4715 10.6013 16.8177 10.4862 16.3431 10.8212L13.5168 12.7893C12.6098 13.3127 11.5025 13.4279 10.5006 13.0929L7.24892 12.025C6.97472 11.9413 6.82705 11.6377 6.92199 11.3656C7.00633 11.1039 7.28052 10.9573 7.55472 11.0306C7.56527 11.0306 11.2072 12.2031 11.2072 12.2031C11.8204 12.3855 12.3653 12.0411 12.536 11.5331C12.7152 10.9782 12.4094 10.3919 11.861 10.214L6.90087 8.60184C5.81596 8.20979 4.35397 8.29078 3.16406 8.95128V14.811L7.30162 15.7415C8.05956 15.907 8.80326 15.9997 9.51983 15.9997Z",
    fill: "#5D5CF5"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRedemptionFailedUser, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/redemption-failed-user.aff3971a.svg";
export { ForwardRef as ReactComponent };